module.exports = __webpack_public_path__ + "static/media/java.74e943d8.png";